import endpointDuckFactory from "./_endpointDuckFactory";
import moment, { Moment, MomentInput } from "moment";
import { RootState } from "data-handler/rootReducer";
import {
  Report,
  MeasureUnit,
  ReportCommodity,
} from "data-handler/ducks/stores";
import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { successToast, errorToast } from "data-handler/ducks/toast";
import { toastFormattedMessages } from "SCConstants";

const reportsDuck = endpointDuckFactory({ endpoint: "reports" });

const RECALCULATE_REQUEST = "SC_REPORTS_RECALCULATE_REQUEST";
const RECALCULATE_SUCCESS = "SC_REPORTS_RECALCULATE_SUCCESS";
const RECALCULATE_FAILURE = "SC_REPORTS_RECALCULATE_FAILURE";

export const recalculateReports = (reportId: number) => ({
  type: RECALCULATE_REQUEST,
  reportId,
});

function* recalculateWorker(action: {
  type: string;
  reportId: number;
}): Generator<any, void, any> {
  try {
    const apiBaseUrl =
      process.env.REACT_APP_API_URL?.replace(/\/v[0-9]+\/?$/, "") || "";
    const response = yield call(
      axios.post,
      `${apiBaseUrl}/v2/reports/${action.reportId}/recalculate/`
    );
    yield put({ type: RECALCULATE_SUCCESS, data: response.data });
    yield put(
      successToast(
        toastFormattedMessages.find(
          (e) => e.name === "toast.recalculateReportSuccess"
        )?.label
      )
    );
    yield put(reportsDuck.fetchDetail(action.reportId, "Report"));
  } catch (error: any) {
    yield put({ type: RECALCULATE_FAILURE, error });
    yield put(
      errorToast(
        toastFormattedMessages.find(
          (e) => e.name === "toast.recalculateReportError"
        )?.label
      )
    );
  }
}

export function* recalculateWatcher() {
  yield takeLatest(RECALCULATE_REQUEST, recalculateWorker);
}

// Recalculate loading state reducer
const initialRecalculateState = {
  isRecalculating: false,
};

export const recalculateReducer = (
  state = initialRecalculateState,
  action: any
) => {
  switch (action.type) {
    case RECALCULATE_REQUEST:
      return { isRecalculating: true };
    case RECALCULATE_SUCCESS:
    case RECALCULATE_FAILURE:
      return { isRecalculating: false };
    default:
      return state;
  }
};

export const getIsRecalculating = (state: RootState) =>
  state.reportsRecalculate?.isRecalculating || false;

export default reportsDuck;

/**
 * True if report is not undefined and its is_editable flag is false. False otherwise.
 */
export const getIsReportLocked = (report: Report | undefined) =>
  report ? !report.is_editable : false;

export const getReportByMoment = (
  state: RootState,
  date: Moment | MomentInput
): Report | undefined => {
  const reports = reportsDuck.getList(state) as Report[];
  const month = moment(date).month() + 1;
  const year = moment(date).year();
  const day = moment(date).date();
  return reports.find(
    (report) =>
      report.month === month &&
      report.year === year &&
      report.start_day <= day &&
      report.end_day >= day
  );
};

export const getReportByYearMonthDay = (
  state: RootState,
  year: number,
  month: number,
  day: number
) => {
  const reports = reportsDuck.getList(state) as Report[];
  return reports.find(
    (report) =>
      report.month === month &&
      report.year === year &&
      report.start_day <= day &&
      report.end_day >= day
  );
};

export const kilogramMeasureUnit: MeasureUnit = {
  id: -1,
  name: "Kilogram",
  symbol: "Kg",
  decimals: 3,
};

export const emptyMeasureUnit: MeasureUnit = {
  id: -1,
  name: "",
  symbol: "",
  decimals: 3,
};

export const missingCommodity: ReportCommodity = {
  id: -1,
  name: "Unidentified",
  measure_unit: emptyMeasureUnit,
};
